
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Schlafentzug gilt als eine mögliche Therapieform bei Depressionen, da er bei gewissen Patienten rasch und – zumindest kurzfristig betrachtet – mit wenig Nebenwirkungen die Stimmung aufhellt. Was dabei passiert, war lange schleierhaft. Beobachtungen zeigen, dass bei Depressionen häufig gewisse Hirnareale zur Regulierung von emotionalen Prozessen überaktiv und solche für rationale Leistungen gehemmt sind. Mehrere Studien kamen zudem zum Schluss, dass in einem bestimmten Knotenpunkt eine zu starke Verknüpfung diverser Hirnareale vorliegt, was als Ursache der emotionalen und kognitiven Fehlregulierung bei Depressionen betrachtet wird. Im Jahr 2013 konnten `}<Link href='https://www.media.uzh.ch/de/medienmitteilungen/archive/2013/schlafentzug.html' mdxType="Link">{`Forscher der Universitätsklinik Zürich`}</Link>{` zeigen, dass Schlafentzug diese Verknüpfung verringert. Laut den Forschern werden Hirnareale, die vor allem für emotionale Prozesse zuständig sind, durch den Schlafentzug eher ausgeschlossen, während Areale für die kognitive Kontrolle eher aktiviert würden. `}<M mdxType="M">{`Eine Wachtherapie kann die Symptome von Depressiven also tatsächlich abschwächen.`}</M>{` Der Nachteil: Der Effekt ist nur von kurzer Dauer und verpufft, sobald die Patienten wieder länger geschlafen haben.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;